import { DateTimeFormatter, LocalDate } from '@js-joda/core';

import log from './log';

const DATE_FORMAT_CLOUD = 'MM/dd/yyyy';
const DATE_FORMAT_FRONTEND = 'yyyy-MM-dd';

export const formatDateFromCloud = (
  dateString: string | undefined,
): LocalDate | undefined => {
  if (dateString) {
    try {
      // Default cloud date format is ISO 8601 (yyyy-MM-dd)
      const formatter = DateTimeFormatter.ofPattern(DATE_FORMAT_CLOUD);

      return LocalDate.parse(dateString, formatter);
    } catch {
      try {
        // Give another try to the default format
        return LocalDate.parse(dateString);
      } catch (error) {
        log.warn('Error parsing date:', error);

        return undefined;
      }
    }
  }

  return undefined;
};

// format DATE_FORMAT_CLOUD to DATE_FORMAT_FRONTEND
export const formatCloudDateToFrontend = (
  dateString: string | undefined,
): string | undefined => {
  if (dateString) {
    try {
      const formatter = DateTimeFormatter.ofPattern(DATE_FORMAT_CLOUD);
      const date = LocalDate.parse(dateString, formatter);

      return date.format(DateTimeFormatter.ofPattern(DATE_FORMAT_FRONTEND));
    } catch (error) {
      log.warn('Error formatting date to cloud format:', error);

      return undefined;
    }
  }

  return undefined;
};
